import {
  ISMOBILEPHONE_CHANGED,
  VISIBLETABS_CHANGED,
  ISTABLET_CHANGED
} from './initial-app-state-const';

const initialState = {
  isMobilePhone: false,
  isTablet: false,
  visibleTabs: {
    isImageListEnable: false,
    isQAEnable: false,
    isEquipmentsEnable: false,
    isEquipmentsAnalysisEnable: false,
    isDocumentsEnable: false
  }
};

export default function(state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type){
    case ISTABLET_CHANGED:
      return {...state, isTablet: action.payload.isTablet};
    case ISMOBILEPHONE_CHANGED:
      return {...state, isMobilePhone: action.payload.isMobilePhone};
    case VISIBLETABS_CHANGED:
      return {...state, visibleTabs: action.payload.visibleTabs};
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** app/components/initial-app-state/state/initial-app-state-reducer.js
 **/